import { FC } from 'react';
import { UnfoldHorizontalIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { PhraseAuditItem } from '@/entities/phrases';
import { PhrasePlayButton } from '@/features/phrase-playback';
import { PHRASE_PADDING_MS } from '../model/constants';
import { getPaddedPhrasePlaybackKey, getPhrasePlaybackKey } from '../model/phrasePlaybackKeys';
import { PhraseTextEditor } from './PhraseTextEditor';

type Props = {
  /** Реплика строки перечня */
  phrase: PhraseAuditItem;
};

/**
 * Ячейка реплики: её текст полем правки и два прослушивания — самой реплики и её же с запасом
 * по краям. Реплика слушается ровно в своих границах — вычитка сверяет текст с тем отрезком записи,
 * который ей принадлежит; запас нужен там, где распознавание срезало начало или конец фразы.
 * Кнопки из обхода с клавиатуры исключены: обход ведёт из текста реплики в текст следующей.
 */
export const PhraseTextCell: FC<Props> = ({ phrase }) => {
  const { t } = useTranslation(['audioAudit']);

  return (
    <div className="flex w-full items-start gap-1">
      <PhraseTextEditor phrase={phrase} />
      <PhrasePlayButton
        conversationId={phrase.conversationId}
        startedAt={phrase.startedAt}
        finishedAt={phrase.finishedAt}
        playbackKey={getPhrasePlaybackKey(phrase.id)}
        leadMs={0}
        isTabbable={false}
      />
      <PhrasePlayButton
        conversationId={phrase.conversationId}
        startedAt={phrase.startedAt}
        finishedAt={phrase.finishedAt}
        playbackKey={getPaddedPhrasePlaybackKey(phrase.id)}
        leadMs={PHRASE_PADDING_MS}
        tailMs={PHRASE_PADDING_MS}
        isTabbable={false}
        playIcon={<UnfoldHorizontalIcon className="size-3.5" />}
        playLabel={t('audioAudit:playWithPadding')}
      />
    </div>
  );
};
